module.exports = {"data":[{"Nivel":"Nivel","code":"0912345","group":"01","AvgAspectIdo":"4.5","AvgResposabilidad":"4.5","AvgActitudForm":"3.0","AvgGeneralApreciacion":"3.8","Periodo":"Período","Asignatura":"Asignatura"}],"status":true}


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/profile/perfil/perfil_docente/dialog/detallePerfilDocente.json
// module id = 427
// module chunks = 0